module.exports = __webpack_public_path__ + "img/st_login.a7e6f5e3.png";